<template>
  <slideout-panel v-on:slideout:close="closePanel" :open="createEmailSettingPanelIsOpen" title="Create Email Setting" >
    <div>
      <email-settings-form />
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import EmailSettingsForm from "@/components/EmailSettings/EmailSettingsForm";
export default {
  name: "CreateEmailSettingPanel",
  components: {EmailSettingsForm, SlideoutPanel},
  props: ['open'],
  methods: {
    closePanel() {
      this.$store.dispatch('closeCreateEmailSettingPanel')
    }
  },
  computed: {
    createEmailSettingPanelIsOpen() {
      return this.$store.getters.getCreateEmailSettingPanelIsOpen
    },
  },
}
</script>

<style scoped>

</style>
